<script lang="ts">
  import type { InputTextProps } from '../types';
  import InputInline from '../InputInline.svelte';

  export let props: InputTextProps;

  let { label, ...rest } = props ?? { label: '' };
</script>

<InputInline type="hidden" bind:props={rest} on:keypress on:keyup />
